import React from 'react';
import RoadmapIsland from './RoadmapIsland';
import { roadmap } from '../../data/roadmap';

const RoadmapMap = () => {
  // simple rows: Done → Now → Next
  const done = roadmap.find(s => s.key === "done");
  const now = roadmap.find(s => s.key === "now");
  const next = roadmap.find(s => s.key === "next");

  return (
    <div className="roadmap-map">
      {/* background grid and stars */}
      <div className="roadmap-map-bg" aria-hidden />
      
      <div className="roadmap-map-grid">
        <Column title="Done" items={done.items} />
        <Column title="Now" items={now.items} emphasis />
        <Column title="Next" items={next.items} />
      </div>
    </div>
  );
};

const Column = ({ title, items, emphasis = false }) => {
  return (
    <div className="roadmap-column">
      <h2 className={`roadmap-column-title ${emphasis ? 'roadmap-column-title--emphasis' : ''}`}>
        {title}
      </h2>
      <div className="roadmap-column-items">
        {items.map((item) => (
          <RoadmapIsland key={item.id} item={item} />
        ))}
      </div>
    </div>
  );
};

export default RoadmapMap;

